module.exports = __webpack_public_path__ + "img/eduardo-santillan.858de6cf.png";